import React from 'react'
import _ from 'lodash'
import moment from 'moment';

class PendingShopListModal extends React.Component {
    state = {
        shopList: []
    }
    // componentWillReceiveProps(nextProps) {
    //     // const { isEdit, selectedUser } = nextProps

    //     this.setState({
    //         // firstName: selectedUser.firstName,
    //     })

    // }

    render() {
        const { currentPendingList, currentItemName } = this.props
        return (
            <div className="modal" id="pendingShopListModal" style={{ perspective: 'none' }} >
                <div className="modal-content" >
                    <div className="modal-header modal-header-colored">
                        <h3 className="modal-title">{currentItemName}</h3>
                        <button className="close modal-close" type="button" className="close" data-dismiss="modal" aria-label="Close" aria-hidden="true"><span className="mdi mdi-close"></span></button>
                    </div>
                    <div className="modal-body form" style={{ padding: 10 }}>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th >Invoice ID</th>
                                    <th >วันที่/เวลา</th>
                                    <th >ชื่อร้าน/สาขา</th>
                                    <th className="number">จำนวน</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    _.map(currentPendingList, line => {
                                        return (
                                            <tr>
                                                <td>{line.invoiceId}</td>
                                                <td>{moment(line.timestamp).format('HH:mm DD/MMM/YYYY')}</td>
                                                <td>{line.shopName}</td>
                                                <td className="number">{line.amount}</td>
                                            </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>


                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary modal-close" type="button" onClick={() => window.$('#pendingShopListModal').modal('hide')}>Close</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default PendingShopListModal